import { DivisiResponse } from "../../../../models/Divisi";
import { AdminJobDetailResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function CreateKandidatFile(KANDIDAT_ID: number) {
  const res = await ApiClient.get(
    `/CreateKandidatFile?KANDIDAT_ID=${KANDIDAT_ID}`
  );
  return res.data[0];
}

export const useCreateKandidatFile = mutationWrapper(CreateKandidatFile);
